// src/components/InPageNavbar.jsx
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { Cancel } from '@mui/icons-material';

const sections = [
  { label: 'Home', target: '#home' },
  { label: 'Features', target: '#features' },
  // { label: 'Pricing', target: '#pricing' },
  { label: 'Contact', target: '#contact' },
];

function Navbar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleNavClick = (target) => {
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setDrawerOpen(false);
  };

  return (
    <>
      <AppBar position="fixed" sx={{background:'#1a1b2f'}} elevation={2}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h6">MiiRA POS</Typography>
          {isMobile ? (
            <>
            

              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
              
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <Box
                  sx={{ width: '80vw',padding:'10px' }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <Cancel onClick={toggleDrawer(false)}></Cancel>
                  <List>
                    {sections.map((section) => (
                      <ListItemButton
                        key={section.label}
                        onClick={() => handleNavClick(section.target)}
                      >
                        <ListItemText primary={section.label} />
                      </ListItemButton>
                    ))}
                    
                  </List>
                  <Button sx={{background: 'tomato' , color:'#fff', px:2,py:1,textAlign:'center'}}
               href='/login' >
                 Admin panel
              </Button>
                </Box>
              </Drawer>
            </>
          ) : (
            <Box>
              {sections.map((section) => (
                <Button
                  key={section.label}
                  color="inherit"
                  href={section.target}
                  sx={{ mx: 1 }}
                >
                  {section.label}
                </Button>
                
              ))}
              <Button sx={{background: 'tomato' , color:'#fff', px:2,py:1}}
               href='/login' >
                 Admin panel
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Navbar;
